// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"268":"Home","936":"LabsHome"}[chunkId] || chunkId) + "." + {"212":"a365b82d","268":"7736f751","495":"b65e69de","644":"592741d6","936":"0db3c7a2"}[chunkId] + ".chunk.css";
};